import ClientMatchesList from "@/components/staffing/ClientMatchesList";
import AssessmentPostingsList from "@/components/staffing/AssessmentPostingsList";
import { CurrentUserContext } from "@/context/CurrentUserContext";
import { isAnalystRole } from "@/utils/staffingUtil";
import { useContext, useEffect } from "react";


const Openings = () => {
    const { currentUser } = useContext(CurrentUserContext);
    // Assessment postings never come back from the match procs, so analyst
    // roles get them as a second table under their matches.
    const showAssessments = isAnalystRole(currentUser.Role);
    useEffect(() => {
        console.log(currentUser.Role)
        console.log(isAnalystRole(currentUser.Role));
        console.log(showAssessments);
    } , [currentUser.Role, showAssessments])
    const matches = (
        <ClientMatchesList
            identifier={currentUser.LoginName}
            isApplicant={false}
            widget={true}
            region={currentUser.Region}
            staffFullName={currentUser.FullName}
            staffRole={currentUser.Role}
        />
    );

    if (!showAssessments) return matches;

    return (
        <div className="flex flex-col gap-4">
            <section>
                <h3 className="mb-2 text-sm font-semibold">Matches</h3>
                {matches}
            </section>
            <section>
                <h3 className="mb-2 text-sm font-semibold">Assessment Postings</h3>
                <AssessmentPostingsList
                    identifier={currentUser.LoginName}
                    region={currentUser.Region}
                    staffFullName={currentUser.FullName}
                    staffRole={currentUser.Role}
                />
            </section>
        </div>
    );
};

export default Openings;
